import * as React from "react";
import { Category } from "./billerCategoryTypes";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import ChevronRight from "@material-ui/icons/ChevronRight";

type Props = {
  categories?: Array<Category>;
  onSelect: (category: Category) => void;
};

type State = {
  selectedCategory: Category | null;
};

export default class CategoriesNestedContainer extends React.Component<
  Props,
  State
> {
  state = { selectedCategory: null };
  static defaultProps = {
    categories: []
  };

  onClickCategory = (category: Category) => {
    if (category === this.state.selectedCategory) {
      this.setState({ selectedCategory: null });
    } else {
      this.setState({ selectedCategory: category });
    }
    this.props.onSelect(category);
  };

  render() {
    const categories = this.props.categories || [];
    return (
      <List component="nav">
        {categories.map((cat, index) => {
          return (
            <div key={index}>
              <ListItem button onClick={() => this.onClickCategory(cat)}>
                <ListItemIcon>
                  <div className="small-icon">
                    <img
                      className="match-parent"
                      alt="No icon"
                      src={cat.icon}
                    />
                  </div>
                </ListItemIcon>
                <ListItemText inset primary={cat.name} />
                {!!cat.sub_categories && cat.sub_categories.length > 0 ? (
                  this.state.selectedCategory === cat ? (
                    <ExpandLess />
                  ) : (
                    <ExpandMore />
                  )
                ) : (
                  <ChevronRight />
                )}
              </ListItem>
              <Collapse
                in={this.state.selectedCategory === cat}
                timeout="auto"
                unmountOnExit
              >
                <div style={{ paddingLeft: 50 }}>
                  <CategoriesNestedContainer
                    onSelect={this.props.onSelect}
                    categories={cat.sub_categories}
                  />
                </div>
              </Collapse>
            </div>
          );
        })}
      </List>
    );
  }
}
